// extracted by mini-css-extract-plugin
module.exports = {"text":"_6c97079b1b--text--jAqoJ","link":"_6c97079b1b--link--TpX5J"};